import React from "react";
// import LazyImage from "../../molecules/layout/Images/LazyImage";
import Image from "@image";
import Link from "next/link";
// import getImageUrlWithCdnPrefix from "../../../utils/getImageUrlWithCdnPrefix";

export default function BlogCategory(props) {
    return (
        <>
            <div className="container">
                <div className="row justify-content-start pt-4">
                    {/* <div className="col-12 col-lg-8 col-md-8"> */}
                    <div className="col-12">
                        <>
                            <h1 className="h3 font-size-34 mb-3">
                                {props.blogCategory.name}
                            </h1>
                            <p className="lead font-size-12 text-muted">
                                {props.blogCategory.description}
                            </p>
                        </>
                    </div>
                </div>
            </div>

            <section className="section section-lg py-6 bg-soft">
                <div className="container z-2">
                    <div className="row justify-content-center">
                        {props.blogPosts.map((post) => (
                            <div className="col-12 col-lg-4 mb-5" key={post.id}>
                                <Link href={`/blog/posts/${post.slug}`}>
                                    <a></a>
                                </Link>
                                <div className="card shadow-soft border-light">
                                    <Link href={`/blog/posts/${post.slug}`}>
                                        <a>
                                            <div className="card-header p-0 custom-header-img">
                                                <Image
                                                    alt={`Blog post ${post.title}`}
                                                    className="card-img-top rounded-top"
                                                    height="217"
                                                    src={post.header_image_file}
                                                    width="347"
                                                    layout="responsive"
                                                    quality={50}
                                                />
                                            </div>
                                        </a>
                                    </Link>
                                    <div className="card-body py-2">
                                        <Link href={`/blog/posts/${post.slug}`}>
                                            <a>
                                                <div className="pl-0 pt-4">
                                                    <span className="font-size-15 font-weight-bold text-dark">
                                                        {post.title}
                                                    </span>
                                                </div>
                                                {/* <div className="pl-0 pt-2 pb-1">
                                                        <p className="text-gray-700"></p>
                                                        <div className="rich-text">
                                                            <p>
                                                                Many people have
                                                                got in touch
                                                                with us at Inuua
                                                                about how they
                                                                can get to
                                                                building their
                                                                o…
                                                            </p>
                                                        </div>
                                                        <p></p>
                                                    </div> */}
                                            </a>
                                        </Link>
                                        <div className="pl-0 pb-3">
                                            <a></a>
                                            <div className="btn-cont">
                                                <Link
                                                    href={`/blog/posts/${post.slug}`}
                                                >
                                                    <a></a>
                                                </Link>
                                                <Link
                                                    href={`/blog/posts/${post.slug}`}
                                                >
                                                    <a>Read More</a>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
